import { createSlice } from "@reduxjs/toolkit";
import { getFacebookAccountList } from "./ThunkActions";
import { iFacebookAccountState, REDUCER_NAME } from "./Types";

const initialState: iFacebookAccountState = {
  isLoading: false,
  facebookAccountList: [], 
  errorMessage: null,
};

export const FacebookAccountSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetFacebookAccountState: () => {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFacebookAccountList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFacebookAccountList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.facebookAccountList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getFacebookAccountList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Payment Gateway data";
        state.isLoading = false;
      });
  },
});

export const { resetFacebookAccountState } = FacebookAccountSlice.actions;
export default FacebookAccountSlice.reducer;